/**
 * This is issue details script.js file
 */

export default {
  name: 'IssueFileList',

  props: {
    fileList: {
      type: Array,
      required: true,
      default: []
    },
    issueUuid: {
      type: String,
      required: true
    }
  },

  /**
   * @override
   */
  data() {
    return {
      filePreview: null,
      fileType: null,
      fileName: null
    };
  },

  methods: {
    /**
     * Ver documento
     * @param {Object} document Documento
     */
    showFile(document) {
      const item = {
        type: {
          is_validated: true,
          type: 'issues',
          uuid: this.issueUuid
        },
        uuid: document.uuid,
        title: document.title
      };

      this.$store.dispatch('bastanteoStore/setNewFloatWindow', item);
    },
    /**
     * Descargar documento
     * @param {Object} documentFile Documento
     */
    download(documentFile) {
      this.$issuesService.getDocument(this.issueUuid, documentFile.uuid).then(res => {
        const urlCreator = window.URL || window.webkitURL;
        this.filePreview = urlCreator.createObjectURL(res);
        this.fileType = res.type;
        this.fileName = documentFile.title;

        const fileLink = document.createElement('a');
        fileLink.href = this.filePreview;
        fileLink.setAttribute('download', this.fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    /**
     * Cerrar modal
     */
    closeModal() {
      this.$bvModal.hide('modalViewDocument');
    },
    openModal() {
      this.$bvModal.show('modalViewDocument');
    }
  }
};
